import React from 'react'
import Flex from "@blocks/Flex";
import Button from '@blocks/Button';
import { ReactComponent as TextIcon } from '@icons/text.svg'
import { ReactComponent as EyeIcon } from '@icons/eye.svg'
import { route } from '@helpers';
import { useSalonContext } from '@customer/components/pages/Salon/context';

export default function SalonCurrentActions() {
    const { salon } = useSalonContext()

    return (
        <Flex gap="5px" flexWrap="wrap">
            <Button type="tertiary" icon={<EyeIcon />} href={route("general:salon", salon.state.slug)} target="_blank" element="a">Information</Button>
            <Button type="tertiary" icon={<TextIcon />} href={route("general:salon:conditions", salon.state.slug)} target="_blank" element="a">Conditions</Button>
        </Flex>
    )

}